interface ICustomReport {
  label: string;
  description: string;
  reportId: string;
  pageId: string;
  uuidParam: string;
}

export const CUSTOM_REPORTS: Record<string, ICustomReport> = {
  revenue_sharing: {
    label: 'Revenue Sharing',
    description:
      'Fees collected each month, split into replacement fees (USEFULL) and late fees due to the campus',
    reportId: '4941db4e-2769-48d8-a24c-431d07dbc23b',
    pageId: 'eENCG',
    uuidParam: 'revenue_sharing.uuid',
  },
};

export const getEnabledCustomReportKeys = (customReports?: string[] | null) =>
  (customReports ?? []).filter((key) =>
    Object.keys(CUSTOM_REPORTS).includes(key),
  );

export const getCustomReportLink = (reportKey: string, uuid: string) => {
  const { reportId, pageId, uuidParam } = CUSTOM_REPORTS[reportKey];
  const params = encodeURIComponent(JSON.stringify({ [uuidParam]: uuid }));

  return `https://lookerstudio.google.com/embed/reporting/${reportId}/page/${pageId}?params=${params}`;
};
